import * as types from '../types';

// ── Unit Actions ──────────────────────────────────────────────────────────────
export const startFetchingUnitActions = (filters: any = {}) => ({
  type: types.UNIT_ACTIONS_FETCH_STARTED,
  payload: filters
});
export const completeFetchingUnitActions = (entities: any, order: any) => ({
  type: types.UNIT_ACTIONS_FETCH_COMPLETED,
  payload: { entities, order }
});
export const failFetchingUnitActions = (error: any) => ({
  type: types.UNIT_ACTIONS_FETCH_FAILED,
  payload: { error }
});

export const startAddingUnitAction = (unitAction: any) => ({
  type: types.UNIT_ACTIONS_ADD_STARTED,
  payload: unitAction
});
export const completeAddingUnitAction = (oldId: any, unitAction: any) => ({
  type: types.UNIT_ACTIONS_ADD_COMPLETED,
  payload: { oldId, unitAction }
});
export const failAddingUnitAction = (oldId: any, error: any) => ({
  type: types.UNIT_ACTIONS_ADD_FAILED,
  payload: { oldId, error }
});

export const startEditingUnitAction = (unitAction: any) => ({
  type: types.UNIT_ACTIONS_EDIT_STARTED,
  payload: unitAction
});
export const completeEditingUnitAction = (unitAction: any) => ({
  type: types.UNIT_ACTIONS_EDIT_COMPLETED,
  payload: unitAction
});
export const failEditingUnitAction = (oldUnitAction: any, error: any) => ({
  type: types.UNIT_ACTIONS_EDIT_FAILED,
  payload: { oldUnitAction, error }
});

export const startRemovingUnitAction = (unitActionId: number) => ({
  type: types.UNIT_ACTIONS_REMOVE_STARTED,
  payload: { unitActionId }
});
export const completeRemovingUnitAction = (unitActionId: number) => ({
  type: types.UNIT_ACTIONS_REMOVE_COMPLETED,
  payload: { unitActionId }
});
export const failRemovingUnitAction = (unitActionId: number, error: any) => ({
  type: types.UNIT_ACTIONS_REMOVE_FAILED,
  payload: { unitActionId, error }
});

// ── Unit Action Configurations ────────────────────────────────────────────────
export const startFetchingUnitActionConfigurations = (filters: any = {}) => ({
  type: types.UNIT_ACTION_CONFIGS_FETCH_STARTED,
  payload: filters
});
export const completeFetchingUnitActionConfigurations = (entities: any, order: any) => ({
  type: types.UNIT_ACTION_CONFIGS_FETCH_COMPLETED,
  payload: { entities, order }
});
export const failFetchingUnitActionConfigurations = (error: any) => ({
  type: types.UNIT_ACTION_CONFIGS_FETCH_FAILED,
  payload: { error }
});

export const startAddingUnitActionConfiguration = (config: any) => ({
  type: types.UNIT_ACTION_CONFIGS_ADD_STARTED,
  payload: config
});
export const completeAddingUnitActionConfiguration = (oldId: any, config: any) => ({
  type: types.UNIT_ACTION_CONFIGS_ADD_COMPLETED,
  payload: { oldId, config }
});
export const failAddingUnitActionConfiguration = (oldId: any, error: any) => ({
  type: types.UNIT_ACTION_CONFIGS_ADD_FAILED,
  payload: { oldId, error }
});

export const startEditingUnitActionConfiguration = (config: any) => ({
  type: types.UNIT_ACTION_CONFIGS_EDIT_STARTED,
  payload: config
});
export const completeEditingUnitActionConfiguration = (config: any) => ({
  type: types.UNIT_ACTION_CONFIGS_EDIT_COMPLETED,
  payload: config
});
export const failEditingUnitActionConfiguration = (oldConfig: any, error: any) => ({
  type: types.UNIT_ACTION_CONFIGS_EDIT_FAILED,
  payload: { oldConfig, error }
});

export const startRemovingUnitActionConfiguration = (unitActionConfigurationId: number) => ({
  type: types.UNIT_ACTION_CONFIGS_REMOVE_STARTED,
  payload: { unitActionConfigurationId }
});
export const completeRemovingUnitActionConfiguration = (unitActionConfigurationId: number) => ({
  type: types.UNIT_ACTION_CONFIGS_REMOVE_COMPLETED,
  payload: { unitActionConfigurationId }
});
export const failRemovingUnitActionConfiguration = (unitActionConfigurationId: number, error: any) => ({
  type: types.UNIT_ACTION_CONFIGS_REMOVE_FAILED,
  payload: { unitActionConfigurationId, error }
});


export const startFetchingUnitActionPermissions = () => ({
  type: types.PERMISSIONS_FETCH_STARTED,
  payload: {}
});
export const completeFetchingUnitActionPermissions = (permissions: any[]) => ({
  type: types.PERMISSIONS_FETCH_COMPLETED,
  payload: { permissions }
});
export const failFetchingUnitActionPermissions = (error: any) => ({
  type: types.PERMISSIONS_FETCH_FAILED,
  payload: { error }
});
